import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";
import Layout from "../../../layout/Layout";
import { agentUser1API, config, userData, statusAPI } from "../../../config";
import {
  Button,
  Grid,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  TextField,
  Typography,
  Snackbar,
  Alert as MuiAlert,
  CircularProgress,
  Backdrop,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Edit, Search } from "@mui/icons-material";
import moment from "moment/moment";
import * as XLSX from "xlsx/xlsx.mjs";
import { MaterialReactTable } from "material-react-table";

const stateList = [
  { state_name: `Andhra Pradesh` },
  { state_name: `Andaman and Nicobar Islands` },
  { state_name: `Arunachal Pradesh` },
  { state_name: `Assam` },
  { state_name: `Bihar` },
  { state_name: `Chandigarh` },
  { state_name: `Chhattisgarh` },
  { state_name: `Dadar and Nagar Haveli` },
  { state_name: `Daman and Diu` },
  { state_name: `Delhi` },
  { state_name: `Lakshadweep` },
  { state_name: `Puducherry` },
  { state_name: `Goa` },
  { state_name: `Gujarat` },
  { state_name: `Haryana` },
  { state_name: `Himachal Pradesh` },
  { state_name: `Jammu and Kashmir` },
  { state_name: `Jharkhand` },
  { state_name: `Karnataka` },
  { state_name: `Kerala` },
  { state_name: `Madhya Pradesh` },
  { state_name: `Maharashtra` },
  { state_name: `Manipur` },
  { state_name: `Meghalaya` },
  { state_name: `Mizoram` },
  { state_name: `Nagaland` },
  { state_name: `Odisha` },
  { state_name: `Punjab` },
  { state_name: `Rajasthan` },
  { state_name: `Sikkim` },
  { state_name: `Tamil Nadu` },
  { state_name: `Telangana` },
  { state_name: `Tripura` },
  { state_name: `Uttar Pradesh` },
  { state_name: `Uttarakhand` },
  { state_name: `West Bengal` },
];

const AdvancedPaginationTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);

  const [excelLoading, setExcelLoading] = useState(false);
  const [exportSuccess, setExportSuccess] = useState(false);

  // MRT State
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  // State for applied external filters (to be updated only on Search click)
  const [appliedExternalFilters, setAppliedExternalFilters] = useState({
    department: "",
    txtLGroup: "",
    txtBranch: "",
    txtState: "",
    name: "",
  });

  const navigate = useNavigate();
  const [department, setDepartment] = useState("");
  const [name, setName] = useState("");
  const [txtLGroup, settxtLGroup] = useState("");
  const [txtBranch, setBranch] = useState("");
  const [txtState, setState] = useState("");
  const [statusID, setStatusID] = useState("");

  const [branchList, setBranchList] = useState([]);
  const [locationGroup, setLocationGroup] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [prioritizationList, setPrioritizationList] = useState([]);
  const [lstLGroup, setLGroupList] = useState([]);
  const [statusList, setStatusList] = useState([]),
    [userList, setUserList] = useState([]),
    [userID, setUserID] = useState(0);

  let filterUseRef = useRef(false);

  useEffect(() => {
    if (filterUseRef.current === false) {
      let data = JSON.stringify({
        limit: 0,
        offset: 0,
        parent_id: "35",
      });
      getStatus(data, "departmentList");

      data = JSON.stringify({
        limit: 0,
        offset: 0,
        parent_id: "82",
      });
      getStatus(data, "setLocationGroup");

      data = JSON.stringify({
        limit: 0,
        offset: 0,
        parent_id: "100",
      });
      getStatus(data, "setBranchList");

      //   data = JSON.stringify({
      //     limit: 0,
      //     offset: 0,
      //     parent_id: "43",
      //   });
      //   getStatus(data, "statusList");

      return () => {
        filterUseRef.current = true;
      };
    }
  }, []);

  const getStatus = (data, type) => {
    config.method = "patch";
    config.url = statusAPI;
    config.data = data;

    axios(config)
      .then(function (response) {
        // if (type === "issueTypeList") setIssueTypeList(response.data["data"]);
        if (type === "setLocationGroup")
          setLocationGroup(response.data["data"]);
        else if (type === "departmentList")
          setDepartmentList(response.data["data"]);
        else if (type === "setBranchList") setBranchList(response.data["data"]);
        else if (type === "statusList") setStatusList(response.data["data"]);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };


  const fetchUsers = async (page, size = pagination.pageSize) => {
    setLoading(true);

    // Map MRT filters
    const filterEmpNo = columnFilters.find(f => f.id === 'emp_no')?.value || null;
    const filterName = columnFilters.find(f => f.id === 'name')?.value || null;
    const filterPhone = columnFilters.find(f => f.id === 'phone')?.value || null;
    const filterEmail = columnFilters.find(f => f.id === 'email')?.value || null;
    const filterDepartment = columnFilters.find(f => f.id === 'department')?.value || null;
    const filterBranch = columnFilters.find(f => f.id === 'branch')?.value || null;
    const filterLocationGroup = columnFilters.find(f => f.id === 'location_group')?.value || null;
    const filterState = columnFilters.find(f => f.id === 'state')?.value || null;
    const filterIsDeptHead = columnFilters.find(f => f.id === 'is_dept_head')?.value || null;
    const filterRoleName = columnFilters.find(f => f.id === 'role_name')?.value || null;
    const filterStatus = columnFilters.find(f => f.id === 'status')?.value || null;

    // Map MRT sorting
    const sortBy = sorting.length > 0 ? sorting[0].id : 'id';
    const sortOrder = sorting.length > 0 ? (sorting[0].desc ? 'DESC' : 'ASC') : 'DESC';

    let data = JSON.stringify({
      limit: size,
      offset: (page - 1) * size,
      intRole: userData.role === "agent" ? 3 : 0,
      intSPType: 3,
      txtDepartment: appliedExternalFilters.department,
      txtLocationGroup: appliedExternalFilters.txtLGroup,
      txtBranch: appliedExternalFilters.txtBranch,
      txtState: appliedExternalFilters.txtState,
      txtField: sortBy,
      txtOrderBy: sortOrder,
      txtName: appliedExternalFilters.name,
      txtSearch: globalFilter,
      filterEmpNo,
      filterName,
      filterPhone,
      filterEmail,
      filterDepartment,
      filterBranch,
      filterLocationGroup,
      filterState,
      filterIsDeptHead,
      filterRoleName,
      filterStatus,
    });

    config.method = "PATCH";
    config.data = data;
    config.url = agentUser1API;

    axios(config)
      .then(function (response) {
        // setUserList(response.data["data"]);
        setData(response.data.data);
        setTotalRows(response.data.count);
        // if (
        //   Math.round(response.data.count / limit) <=
        //   response.data.count / limit
        // ) {
        //   setTotalCount(Math.round(response.data.count / limit) + 1);
        // } else {
        //   setTotalCount(Math.round(response.data.count / limit));
        // }
        // console.log(Math.round(response.data.count / limit));

        setLoading(false);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchUsers(pagination.pageIndex + 1, pagination.pageSize);
  }, [pagination.pageIndex, pagination.pageSize, globalFilter, sorting, columnFilters, appliedExternalFilters]);

  const handleEdit = (UserID) => {
    navigate("/agent/user/" + UserID);
  };

  const columns = useMemo(
    () => [
      {
        name: "Emp No",
        field: "emp_no",
        sortable: true,
        cell: (row) => row.emp_no,
      },
      {
        name: "Name",
        field: "name",
        sortable: true,
        cell: (row) => row.name,
      },
      {
        name: "Phone",
        field: "phone",
        sortable: true,
        cell: (row) => (row.phone === `undefined` ? `-` : row.phone),
      },
      {
        name: "Email",
        field: "email",
        sortable: true,
        cell: (row) => row.email,
        width: "18%",
      },
      {
        name: "Department",
        field: "department",
        sortable: true,
        cell: (row) => row.department,
        width: "10%",
      },
      {
        name: "Branch",
        field: "branch",
        sortable: true,
        cell: (row) => row.branch,
      },
      {
        name: "Location Group",
        field: "location_group",
        sortable: true,
        cell: (row) => row.location_group,
      },
      {
        name: "State",
        field: "state",
        sortable: true,
        cell: (row) => row.state,
      },
      {
        name: "Role",
        cell: (row) =>
          row.role_name === "user"
            ? "User"
            : row.role_name === "agent"
            ? "Admin"
            : row.role_name === "Admin"
            ? "Super Admin"
            : "",
        width: "5%",
        center: true,
      },
      {
        name: "Department Head",
        field: "is_dept_head",
        sortable: true,
        cell: (row) => (row.is_dept_head === 1 ? `Yes` : `No`),
      },
      {
        name: "Status",
        cell: (row) => (row.status === 1 ? `Active` : `Inactive`),
        width: "5.5%",
        center: true,
      },
      {
        name: "Created At",
        cell: (row) => moment(row.created_at).format("ddd, DD MMM Y, hh:mm A"),
        width: "10%",
      },
      {
        name: "",
        // eslint-disable-next-line react/button-has-type
        cell: (row) => (
          <Tooltip title="Edit User">
            <Button onClick={() => handleEdit(row.id)}>
              <Edit />
            </Button>
          </Tooltip>
        ),
        width: "3%",
        center: true,
      },
    ],
    [handleEdit]
  );

  const downloadExcel = () => {
    setExcelLoading(true);

    // Map MRT filters
    const filterEmpNo = columnFilters.find(f => f.id === 'emp_no')?.value || null;
    const filterName = columnFilters.find(f => f.id === 'name')?.value || null;
    const filterPhone = columnFilters.find(f => f.id === 'phone')?.value || null;
    const filterEmail = columnFilters.find(f => f.id === 'email')?.value || null;
    const filterDepartment = columnFilters.find(f => f.id === 'department')?.value || null;
    const filterBranch = columnFilters.find(f => f.id === 'branch')?.value || null;
    const filterLocationGroup = columnFilters.find(f => f.id === 'location_group')?.value || null;
    const filterState = columnFilters.find(f => f.id === 'state')?.value || null;
    const filterIsDeptHead = columnFilters.find(f => f.id === 'is_dept_head')?.value || null;
    const filterRoleName = columnFilters.find(f => f.id === 'role_name')?.value || null;
    const filterStatus = columnFilters.find(f => f.id === 'status')?.value || null;

    // Map MRT sorting
    const sortBy = sorting.length > 0 ? sorting[0].id : 'id';
    const sortOrder = sorting.length > 0 ? (sorting[0].desc ? 'DESC' : 'ASC') : 'DESC';

    let data = JSON.stringify({
      limit: 0,
      offset: 0,
      intRole: userData.role === "agent" ? 3 : 0,
      intSPType: 3,
      txtDepartment: appliedExternalFilters.department,
      txtLocationGroup: appliedExternalFilters.txtLGroup,
      txtBranch: appliedExternalFilters.txtBranch,
      txtState: appliedExternalFilters.txtState,
      txtField: sortBy,
      txtOrderBy: sortOrder,
      txtName: appliedExternalFilters.name,
      txtSearch: globalFilter,
      filterEmpNo,
      filterName,
      filterPhone,
      filterEmail,
      filterDepartment,
      filterBranch,
      filterLocationGroup,
      filterState,
      filterIsDeptHead,
      filterRoleName,
      filterStatus,
    });

    config.method = "PATCH";
    config.data = data;
    config.url = agentUser1API;

    axios(config)
      .then(function (response) {
        const newData = response.data["data"].map((row) => {
          delete row.tableData;

          row.created_at = moment(row.created_at).format(
            "ddd, DD MMM Y, hh:mm A"
          );
          return row;
        });

        console.log(newData);
        const workSheet = XLSX.utils.json_to_sheet(newData);
        const workBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workBook, workSheet, "students");
        //Buffer
        let buf = XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
        //Binary string
        XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
        //Download
        XLSX.writeFile(
          workBook,
          `RTS-user-${moment().format("ddd, DD MMM Y, hh:mm A")}.xlsx`
        );
        setExcelLoading(false);
        setExportSuccess(true);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
        setExcelLoading(false);
      });
  };

  const options = stateList.map((option) => {
    const firstLetter = option.state_name[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
    };
  });

  return (
    <>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 9999,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
        open={excelLoading}
      >
        <CircularProgress color="inherit" size={56} />
        <Typography variant="h6" color="inherit">
          Exporting Excel...
        </Typography>
      </Backdrop>

      <Snackbar
        open={exportSuccess}
        autoHideDuration={3000}
        onClose={() => setExportSuccess(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <MuiAlert elevation={6} variant="filled" severity="success" onClose={() => setExportSuccess(false)}>
          Excel file exported successfully!
        </MuiAlert>
      </Snackbar>

      <Grid container spacing={2}>
        <Grid item xs={12} lg={12} md={12}>
        <div className={`background--white`}>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={3} md={3}>
              {/* <MuiSelect
                handleChange={handleDepartmentListChange}
                label={"Department"}
                field={department}
                data={departmentList}
              /> */}

              <Autocomplete
                multiple
                id="tags-outlined"
                options={departmentList}
                getOptionLabel={(option) => option.name}
                filterSelectedOptions
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Department"
                    placeholder="Department"
                  />
                )}
                onChange={(event, newValue) => {
                  console.log(newValue);
                  setDepartment("");
                  if (newValue !== null) {
                    let temp = "";
                    for (let i = 0; i < newValue.length; i++) {
                      temp += newValue[i].name + ",";
                    }
                    temp = temp.substring(0, temp.length - 1);
                    setDepartment(temp);
                  }
                }}
              />
            </Grid>

            <Grid item xs={12} lg={3} md={3}>
              <FormControl className={`form-control`} fullWidth>
                {/* <InputLabel id="demo-simple-select-label">
                  Location Group
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={txtLGroup}
                  label="Location Group"
                  onChange={(e) => {
                    settxtLGroup(e.target.value);
                  }}
                >
                  <MenuItem value={`North`}>North</MenuItem>
                  <MenuItem value={`East`}>East</MenuItem>
                  <MenuItem value={`West`}>West</MenuItem>
                  <MenuItem value={`South`}>South</MenuItem>
                  <MenuItem value={`International`}>International</MenuItem>
                </Select> */}

                <Autocomplete
                  multiple
                  id="tags-outlined"
                  options={locationGroup}
                  getOptionLabel={(option) => option.name}
                  filterSelectedOptions
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Location Group"
                      placeholder="Location Group"
                    />
                  )}
                  onChange={(event, newValue) => {
                    console.log(newValue);
                    settxtLGroup("");
                    if (newValue !== null) {
                      //   settxtLGroup(newValue.state_name);
                      let temp = "";
                      for (let i = 0; i < newValue.length; i++) {
                        temp += newValue[i].name + ",";
                      }
                      temp = temp.substring(0, temp.length - 1);
                      settxtLGroup(temp);
                    }
                  }}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} lg={3} md={3}>
              {/* <TextField
                label="Branch"
                fullWidth
                value={txtBranch}
                onChange={(e) => setBranch(e.target.value)}
              /> */}
              <Autocomplete
                multiple
                id="tags-outlined"
                options={branchList}
                getOptionLabel={(option) => option.name}
                filterSelectedOptions
                renderInput={(params) => (
                  <TextField {...params} label="Branch" placeholder="Branch" />
                )}
                onChange={(event, newValue) => {
                  console.log(newValue);
                  setBranch("");
                  if (newValue !== null) {
                    // setBranch(newValue.state_name);
                    let temp = "";
                    for (let i = 0; i < newValue.length; i++) {
                      temp += newValue[i].name + ",";
                    }
                    temp = temp.substring(0, temp.length - 1);
                    setBranch(temp);
                  }
                }}
              />
            </Grid>

            <Grid item xs={12} lg={3} md={3}>
              <FormControl className={`form-control`} fullWidth>
                <Autocomplete
                  id="combo-box-demo"
                  options={options}
                  groupBy={(option) => option.firstLetter}
                  getOptionLabel={(option) => option.state_name}
                  fullWidth
                  renderInput={(params) => (
                    <TextField {...params} label="State" variant="outlined" />
                  )}
                  onChange={(event, newValue) => {
                    console.log(newValue);
                    setState("");
                    if (newValue !== null) {
                      // setUserID(newValue.id);
                      setState(newValue.state_name);
                    }
                  }}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} lg={3} md={3}>
              <TextField
                label="Emp No, Name, Phone or Email"
                fullWidth
                onChange={(e) => setName(e.target.value)}
                value={name}
              />
            </Grid>

            <Grid
              item
              xs={12}
              lg={12}
              md={12}
              textAlign={`center`}
              display={`flex`}
              justifyContent={`center`}
              gap={`10px`}
            >
              <Button
                className="btn-primary"
                onClick={() => {
                  setAppliedExternalFilters({
                    department,
                    txtLGroup,
                    txtBranch,
                    txtState,
                    name,
                  });
                  setPagination((prev) => ({ ...prev, pageIndex: 0 }));
                }}
                startIcon={<Search />}
              >
                Search
              </Button>

              <Button
                className="btn-primary"
                onClick={() => {
                  // navigate("/agent/list");
                  window.location.href = "/agent/user/list";
                }}
              >
                Reset Search
              </Button>
            </Grid>
          </Grid>
        </div>
      </Grid>
      <Grid item xs={12} lg={12} md={12} textAlign={`right`}>
        <Button className="btn-primary" onClick={downloadExcel}>
          Export to Excel
        </Button>
      </Grid>
      <Grid item xs={12} lg={12} md={12}>
        <MaterialReactTable
          columns={[
            {
              accessorKey: "emp_no",
              header: "Emp No",
            },
            {
              accessorKey: "name",
              header: "Name",
            },
            {
              accessorKey: "phone",
              header: "Phone",
              Cell: ({ cell }) => (cell.getValue() === "undefined" ? "-" : cell.getValue()),
            },
            {
              accessorKey: "email",
              header: "Email",
              size: 200,
            },
            {
              accessorKey: "department",
              header: "Department",
            },
            {
              accessorKey: "branch",
              header: "Branch",
            },
            {
              accessorKey: "location_group",
              header: "Location Group",
            },
            {
              accessorKey: "state",
              header: "State",
            },
            {
              accessorKey: "role_name",
              header: "Role",
              Cell: ({ cell }) => {
                const role = cell.getValue();
                return role === "user"
                  ? "User"
                  : role === "agent"
                  ? "Admin"
                  : role === "Admin"
                  ? "Super Admin"
                  : role;
              },
              size: 100,
            },
            {
              accessorKey: "is_dept_head",
              header: "Department Head",
              Cell: ({ cell }) => (cell.getValue() === 1 ? "Yes" : "No"),
              size: 100,
            },
            {
              accessorKey: "status",
              header: "Status",
              id: "status",
              Cell: ({ cell }) => (cell.getValue() === 1 ? "Active" : "Inactive"),
              size: 100,
            },
            {
              accessorKey: "created_at",
              header: "Created At",
              Cell: ({ cell }) => moment(cell.getValue()).format("ddd, DD MMM Y, hh:mm A"),
              size: 200,
            },
            {
              id: "actions",
              header: "Actions",
              Cell: ({ row }) => (
                <Tooltip title="Edit User">
                  <Button onClick={() => handleEdit(row.original.id)}>
                    <Edit />
                  </Button>
                </Tooltip>
              ),
              size: 50,
            },
          ]}
          data={data}
          manualFiltering
          manualPagination
          manualSorting
          onColumnFiltersChange={setColumnFilters}
          onGlobalFilterChange={setGlobalFilter}
          onPaginationChange={setPagination}
          onSortingChange={setSorting}
          rowCount={totalRows}
          state={{
            columnFilters,
            globalFilter,
            isLoading: loading,
            pagination,
            sorting,
          }}
          enableGlobalFilter={true}
          enableFullScreenToggle={false}
          enableDensityToggle={false}
          enableHiding={false}
          enableStickyHeader={true}
          muiTableContainerProps={{
            className: "settings-table-scroll",
            sx: {
              maxHeight: "500px",
              overflowY: "scroll",
              overflowX: "auto",
              scrollbarGutter: "stable",
            },
          }}
          muiTablePaperProps={{
            elevation: 0,
            sx: {
              borderRadius: "0",
              border: "1px solid #e0e0e0",
            },
          }}
          muiTableHeadCellProps={{
            sx: {
              backgroundColor: "#f5f5f5",
              color: "#333",
              fontWeight: "bold",
            },
          }}
        />
      </Grid>
    </Grid>
    </>
  );
};

function MuiSelect(props) {
  return (
    <FormControl fullWidth>
      <InputLabel id={props.label}>{props.label}</InputLabel>
      {/* <Select
        labelId={props.label}
        id="demo-simple-select-helper"
        value={props.field}
        label={props.label}
        onChange={props.handleChange}
        name="ddlType"
      >
        {props.data.map((row, index) => (
          <MenuItem value={row.id} key={index}>
            {row.name}
          </MenuItem>
        ))} */}

      <Autocomplete
        id="combo-box-demo"
        options={props.data}
        fullWidth
        renderInput={(params) => (
          <TextField {...params} label="State" variant="outlined" />
        )}
        onChange={(event, newValue) => {
          console.log(newValue);
        }}
      />
      {/* </Select> */}
    </FormControl>
  );
}

export default function UsersList1() {
  return (
    <Layout>
      <AdvancedPaginationTable />
    </Layout>
  );
}
